import { http } from './index'

/**
 * @template T
 * @typedef {Object} TCbResoult
 * @property {T} data
 * @property {Tlinks} links
 * @property {Tmeta} meta
 */

/**
 * @typedef {Object} pagePms
 * @property {number} page 当前页
 * @property {number} per_page 每页条数
 */

/**
 * 获取谱音同步器里面音频勾选了运行制作演唱题的数据
 * @param {pagePms} pms
 * @returns {Promise<TCbResoult<Array<any>>>}
 */
export const getMusicalQuestionLists = pms => {
	return http({
		url: '/api/edu/musical-question-lists',
		method: 'get',
		params: pms
	})
}

